import React, { useState, useEffect } from "react";
import { Grid, Typography } from "@deere/fuel-react";
import TemplateSection from "./TemplateSection";
import SupplierData2 from "./SupplierData2";
import ButtonSection from "./ButtonSection";
import { ErrorCard } from "../../components/ErrorCard";
import CustomAlert from "../../components/CustomAlert";
import { ERR_DESC_REQUEST_NUMBER, ERR_TITLE_REQUEST_NUMBER } from "../../utils/errorLiterals";
import { useUserInfo } from "../../providers/userProvider";
import { Redirect, useLocation } from "react-router-dom";
import { getSubtierCatalogue } from "../../services/survey.service";
import { useOktaAuth } from "@okta/okta-react";
import { Form } from "@deere/ux.uxframe-react";
import { EMPTY_VALUES_ERR, INVALID_COUNTRY_ERR, NON_OKTA_USER } from "../../utils/surveyLiterals";
import { getDateFromTimeStamp } from "../../utils/utils";

const HomeSTPage = (props) => {
  const queryParams = new URLSearchParams(window.location.search);
  let rn = queryParams.get("rn");

  const { authState } = useOktaAuth();
  const [error, setError] = useState({ errorList: [], show: false, title: "Please fix the listed errors and try again" });
  const [saved, setSaved] = useState(false);
  const [rnNotCorrect, setrnNotCorrect] = useState(false);
  const [catalogueData, setCatalogueData] = useState([]);
  const [validated, setValidated] = useState(false);
  const [loading, setloading] = useState(true);
  const userInfo = useUserInfo();
  const location = useLocation();
  const supplierName = location.state ? location.state.supplierName : "";
  const supplierNo = location.state ? location.state.supplierName.split(" - ")[0] : "";
  const endDate = location.state && location.state.endDate ? getDateFromTimeStamp(new Date(location.state.endDate)) : "";
  const updatedBy = location.state && location.state.campaign && location.state.campaign.updatedBy && location.state.campaign.updatedBy !== NON_OKTA_USER ? location.state.campaign.updatedBy : "";
  const updatedOn = location.state && location.state.campaign && location.state.campaign.updatedts ? getDateFromTimeStamp(new Date(location.state.campaign.updatedts)) : "";

  let biRef = {};

  let isAdmin = false;
  if (location.state) {
    if (location.state.isAdmin !== undefined) isAdmin = location.state.isAdmin;
  }

  if (rn === null && location.state) {
    if (location.state.queryParam !== undefined) rn = location.state.queryParam;
  }

  let isAuthMethodOkta = authState && authState.isAuthenticated ? true : false;
  let nonOktaAuthFailed = !isAuthMethodOkta ? (location.state && location.state.isAuthNonOkta ? false : true) : false;
  let token = isAuthMethodOkta ? authState.accessToken.accessToken : "";

  useEffect(() => {
    if (window.location.pathname === "/stext") props.setShowHeaderFooter(false);

    if (!location.state) setrnNotCorrect(true);
    else if (location.state.surveyCode) {
      getSubtierCatalogue(location.state.surveyCode, token, isAuthMethodOkta).then((res) => {
        if (res) {
          setCatalogueData(res);
          setloading(false);
        } else setloading(false);
      });
    }
  }, []);

  const displayErrorCard = (msg, heading, display = true) => {
    setError((prevState) => {
      if (!display) return { ...prevState, show: false };
      if (heading) return { ...prevState, errorList: msg, show: true, title: heading };
      return { ...prevState, errorList: msg, show: true };
    });
    if (display) {
      setSaved(false);
      window.scrollTo(0, 0);
    }
    if (msg[0] === INVALID_COUNTRY_ERR) setValidated(true);
  };

  const displaySaveAlert = () => {
    setError((prevState) => {
      return { ...prevState, show: false };
    });
    setSaved(true);
    window.scrollTo(0, 0);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (!form.checkValidity()) {
      setValidated(true);
      displayErrorCard([EMPTY_VALUES_ERR]);
    } else {
      biRef.saveFunction(true);
    }
  };

  const setLoadingSuppData = (value) => {
    biRef.setLoading(value);
  };

  if (!rn || rn === "" || rnNotCorrect || nonOktaAuthFailed) {
    return (
      <Redirect
        to={{
          pathname: "/error",
          state: { errorTitle: ERR_TITLE_REQUEST_NUMBER, errorDescription: ERR_DESC_REQUEST_NUMBER, errorUrl: window.location.href, errorUser: userInfo ? userInfo.userID : "" },
        }}
      />
    );
  }
  return (
    <>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <Grid container>
          <Grid item xs={12} mb={6} mt={4}>
            <Typography variant="h1" fontWeight="regular">
              Sub-Tier (ST) Survey
            </Typography>
            <Typography variant="h5" gutterBottom>
              {supplierName}
            </Typography>
            {endDate !== "" && (
              <Typography variant="h5" gutterBottom>
                Due date {endDate}
              </Typography>
            )}
            {updatedOn !== "" && (
              <Typography variant="h5" gutterBottom>
                Last saved on {updatedOn} {updatedBy !== "" ? "by " + updatedBy : ""}
              </Typography>
            )}
          </Grid>
          <Grid item xs={12}>
            {error.show && <ErrorCard errors={error.errorList} title={error.title} />}
            {saved && <CustomAlert accessibilityLabel="success" variant="success" title="Your survey has been saved but not submitted." />}
          </Grid>
          <Grid item xs={12} mb={6}>
            <TemplateSection supplierId={supplierNo} displayErrorCard={displayErrorCard} catalogueData={catalogueData} isAuthMethodOkta={isAuthMethodOkta} setLoadingSuppData={setLoadingSuppData} />
          </Grid>
          <Grid item xs={12} mb={6}>
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <Grid item xs={12} mb={6}>
                <SupplierData2 supplierId={supplierNo} displayErrorCard={displayErrorCard} showActions={true} catalogueData={catalogueData} isAuthMethodOkta={isAuthMethodOkta} biRef={biRef} />
              </Grid>
              <Grid item xs={12} style={{ position: "sticky", bottom: 0 }}>
                <ButtonSection
                  rn={rn}
                  supplierId={supplierNo}
                  displayErrorCard={displayErrorCard}
                  displaySaveAlert={displaySaveAlert}
                  showActions={true}
                  isAdmin={isAdmin}
                  isAuthMethodOkta={isAuthMethodOkta}
                  supplierName={supplierName}
                  supplierNo={supplierNo}
                  biRef={biRef}
                  endDate={location.state && location.state.endDate ? location.state.endDate : ""}
                  campaign={location.state && location.state.campaign ? location.state.campaign : null}
                />
              </Grid>
            </Form>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default HomeSTPage;
